<template>
	<div class="order">
		<Header title="确认订单" background="white" />
		<div class="base-card">
			<h4 class="card-title">我的地址</h4>
			<div class="card-content">
				<router-link :to="`/my/address?select=${address.id}&info=${$route.query.info}`" class="flex-center"
					v-if="address">
					<img src="../../../assets/img/classify/add@2x.png" alt="" class="big-icon" />
					<div class="info-card">
						<div>
							<strong>{{ address.name }}</strong>
							<span>{{ address.mobile }}</span>
						</div>
						<p>{{ address.areaName }}{{ address.address }}</p>
					</div>
					<img src="../../../assets/img/classify/jinru_da@2x.png" alt="" class="icon" />
				</router-link>
				<router-link to="/my/address?select=&info=${$route.query.info}" class="flex-center" v-else>
					<img src="../../../assets/img/classify/add@2x.png" alt="" class="big-icon" />
					<div class="info-card">请选择地址</div>
					<img src="../../../assets/img/classify/jinru_da@2x.png" alt="" class="icon" />
				</router-link>
			</div>
		</div>
		<div class="base-card">
			<h4 class="card-title">商品详情</h4>
			<div class="card-content">
				<div class="details-item" v-for="item in list" :key="item.id">
					<van-image :src="item.thumb" alt="" class="details-icon" />
					<div class="flex-column flex-between">
						<p>{{ item.title }}</p>
						<p class="flex-between">
							<span>{{ item.marketPrice }}日元({{ item.realPrice }}人民币)</span>
							<span style="color: #333">x1</span>
						</p>
					</div>
				</div>
			</div>
		</div>
		<div class="base-card">
			<h4 class="card-title">费用详情</h4>
			<div class="card-content">
				<div class="flex-between">
					<p>商品总价</p>
					<p>
						{{ info.goodsPriceJp || 0 }}日元({{ info.goodsPrice || 0 }}人民币)
					</p>
				</div>
				<!-- <div class="flex-between" v-if="false">
          <p>活动优惠</p>
          <p class="main-color">立减4人民币/单</p>
        </div> -->
				<div class="flex-between" v-if="mercari && weekDay != 0 && weekDay != 5 && weekDay != 6 && info.commissionFee != 0">
					<p>优惠券</p>
					<!-- <p class="main-color">立减20人民币</p> -->
					<!-- <van-dropdown-menu @change="changeCoupons">
			<van-dropdown-item v-model="coupons" :options="couponsList" />
			</van-dropdown-menu> -->
					<el-select class="selectCoupons" v-model="couponsTitle" @change="changeCoupons" value-key="id">
						<el-option value="" label="不使用优惠券"></el-option>
						<el-option v-for="(item, index) in couponsList" :value="item" :label="item.name + item.cutMoney"
							:key="index"></el-option>
					</el-select>
				</div>

				<div class="flex-between" v-if="mercari && info.commissionFee != 0">
					<p>满减</p>
					<el-select class="selectCoupons" v-model="discountTitle" @change="changeDiscount" value-key="id">
						<el-option value="" label="不参与满减"></el-option>
						<template v-for="(item, index) in discountList">
							<el-option v-if="item.canUse" :value="item" :label="item.name + item.cutMoney"></el-option>
						</template>
					</el-select>
				</div>

				<div class="flex-between">
					<p>手续费(免手续费时不能再使用优惠券和满减活动)</p>
					<p>{{ info.commissionFee }}人民币</p>
				</div>
				<div class="flex-between">
					<p>配送</p>
					<p v-if="info.freight">{{ info.freight }}</p>
					<p v-else>包邮</p>
				</div>
			</div>
		</div>


		<div class="bottom-bar" v-if="false">
			<wx-open-subscribe template="3siOZRD9ty8ENjgL44XP0KkbZJNTFzQFRwAvlMisuuk" id="subscribe-btn"
				ref="subscribeBtn" style="z-index: 1000;" @success="subscribeSuccess" @fail="subscribeFail">
				<script type="text/wxtag-template" slot="style">
					<style>
						.subscribe-btn {
							height: 100%;
							background-color: #fd0212;
							font-size: 18px;
							color: #ffffff;
							width: 100%;
							border-style: none;
						}
						.subscribe-btn:active {
							background-color: #d50614;
						}
					</style>
				</script>
				<script type="text/wxtag-template">
					<button class="subscribe-btn">
						点我订阅订单代拍状态通知，必须先订阅才能下单      
					</button>
				</script>
			</wx-open-subscribe>
		</div>
		<div class="bottom-bar">
			<p>
				<span>合计：</span>
				<span>￥{{ newGoodsPrice || info.goodsPrice }}</span>
				<!-- <del>119.89</del> -->
			</p>
			<button @click="submit">提交订单</button>
		</div>


	</div>
</template>

<script type="text/ecmascript-6">
import wx from "weixin-js-sdk";
export default {
	data() {
		return {
			info: {},
			list: [],
			address: null,
			proList: [],
			coupons: "",
			couponsTitle: "",
			couponsList: [],
			discount: "",
			discountList: [],
			carIds: {},
			newGoodsPrice: undefined,
			id: "",
			weekDay: -1,
			mercari: true,
			coupon_tip: "不使用优惠券",
			discountTitle: "不参与满减",
			couponsCut: 0,
			discountCut: 0,
			shareUserId: '',
			subscribe: true,
		};
	},
	watch: {
		"$route.path": {
			handler(val) {
				console.log(val, "监听路由");
				this.id = this.$route.query.id ? this.$route.query.id : "";
				console.log(this.id, "id");
				this.getDefAddress(this.id);
			},
		},
	},
	methods: {
		subscribeSuccess() {
			this.subscribe = true;
			this.$toast("订阅成功");
		},
		subscribeFail() {
			this.subscribe = false;
			this.$toast("必须订阅才能购买");
		},
		getJssdkConfig() {
			var _this = this;
			var url_list = window.location.href.split("#");
			var path0 = url_list[0];
			var path1 = url_list[1];
			url_list = path0.split("?");
			var timestamp = new Date().valueOf();
			this.$post({
				url: "/portal/Wechat",
				module: "Index",
				interface: "1001",
				data: {
					pageUrl: path0,
				},
			}).then((res) => {
				console.log("1.0 jssdk", res);
				// res.debug = true;
				wx.config(res);
			})
		},
		changeCoupons(e) {
			console.log(e, 3);
			if (e) {
				this.coupons = e.id;
				// this.coupons = e.cutMoney;
				this.couponsTitle = e.name + e.cutMoney;

				this.couponsCut = e.cutMoney;
				this.discountCut = 0;

				this.discount = ""
				this.discountTitle = "不参与满减"
			} else {
				this.coupons = ""
				this.couponsTitle = "不使用优惠券"
				this.couponsCut = 0;
				// this.newGoodsPrice = this.info.goodsPrice
			}
			this.newGoodsPrice = (this.info.goodsPrice - this.discountCut - this.couponsCut).toFixed(3);


			console.log(this.newGoodsPrice, 1);
		},
		changeDiscount(e) {
			if (e) {
				this.discount = e.id;
				// this.coupons = e.cutMoney;
				this.discountTitle = e.name + e.cutMoney;
				// this.newGoodsPrice = (this.info.goodsPrice - e.cutMoney).toFixed(3);

				this.couponsCut = 0;
				this.discountCut = e.cutMoney;



				this.coupons = ""
				this.couponsTitle = "不使用优惠券"
			} else {
				this.discount = ""
				this.discountTitle = "不参与满减"
				// this.newGoodsPrice = this.info.goodsPrice
				this.discountCut = 0;
			}
			this.newGoodsPrice = (this.info.goodsPrice - this.discountCut - this.couponsCut).toFixed(3);
		},
		submit() {
			if (!this.address) {
				this.$toast("请先选择地址");
				return;
			}
			console.log(this.proList);
			this.$post({
				url: "/portal/Shop",
				module: "Order",
				interface: "1001",
				data: {
					addressId: this.address.id, // 必选 收货地址ID。未添加收货地址时传0
					goodsList: this.proList, // 必选 参与下单的商品列表
					couponId: this.coupons ? this.coupons : undefined,
					discountId: this.discount ? this.discount : undefined,
					shareUserId: this.shareUserId != 'undefined' ? this.shareUserId : 0,
				},
			})
				.then((res) => {
					let ids = res.ids;
					this.$post({
						url: "/portal/Shop",
						module: "Order",
						interface: "1102",
						data: {
							ids: res.ids,
							payType: "220",
						},
					})
						.then((res) => {
							let sign = JSON.parse(res.charge);
							// console.log(sign,333)
							let _this = this;
							// eslint-disable-next-line no-undef
							WeixinJSBridge.invoke(
								"getBrandWCPayRequest", {
								appId: sign.appId, //公众号名称，由商户传入
								timeStamp: sign.timeStamp.toString(), //时间戳，自1970年以来的秒数
								nonceStr: sign.nonceStr, //随机串
								package: sign.package,
								signType: "MD5", //微信签名方式：
								paySign: sign.paySign, //微信签名
							},
								function (res) {
									if (res.err_msg == "get_brand_wcpay_request:ok") {
										// _this.$toast('支付成功')
										_this.buySuccess(ids);
									} else {
										_this.$toast("支付失败，请稍后再试");
									}
								}
							);
						})
						.catch((error) => {
							console.log(error);
							this.$router.replace({
								name: "classifyCommoditysuccess",
								params: {
									payMoney: this.info.goodsPrice,
									success: false,
								},
							});
						});
				})
				.catch((err) => {
					this.$toast(err.message || "下单失败");
				});
		},
		buySuccess(ids) {
			// this.$toast('支付成功')
			this.$router.push({
				path: "/classify/commodity/success",
				query: {
					payMoney: this.info.goodsPrice,
					success: true,
					id: ids,
				},
			});
			// this.$router.replace({
			//   name: "classifyCommoditysuccess",
			//   params: {
			//     payMoney: this.info.goodsPrice,
			//     success: true,
			// 	id:res.ids[0]
			//   },
			// });
		},
		//查询订单
		preOrder(info) {
			console.log(info, "123456");
			// this.proList = info.map((item) => {
			//   return {
			//     goodsId: item, // 必选 商品ID
			//     skuId: 0, // 必选 商品SKU ID。不存在时传0
			//     num: 1, // 必选 商品数量
			//   };
			// });
			let carIds = "";
			if (this.$route.query.carIds) {
				carIds = JSON.parse(decodeURIComponent(this.$route.query.carIds));
			}

			console.log(carIds, 12);
			for (let i = 0; i < info.length; i++) {
				this.proList.push({
					goodsId: info[i], // 必选 商品ID
					skuId: 0, // 必选 商品SKU ID。不存在时传0
					num: 1, // 必选 商品数量
					cartId: carIds[i],
				});
			}
			console.log(this.proList, 234);
			this.$post({
				url: "/portal/Shop",
				module: "Order",
				interface: "1000",
				data: {
					addressId: 0,
					goodsList: this.proList,
				},
			}).then((res) => {
				// console.log("预下单信息", res);
				this.info.goodsPrice = res.goodsPrice;
				this.info.goodsPriceJp = res.goodsPriceJp;
				this.info.commissionFee = res.commissionFee;

				this.mercari = res.goodsList[0].list[0].goods.code != ''

				this.info.freight = parseFloat(res.freight);
				this.list = res.goodsList[0].list.map((item) => {
					return item.goods;
				});
				this.selectCoupons(this.info.goodsPrice);
				this.selectDiscount(this.info.goodsPrice);
			});
			// console.log(info);
		},
		//查询优惠券
		selectCoupons(money) {
			this.$post({
				url: "/portal",
				module: "User",
				interface: "6002",
				data: {
					money: money,
				},
			}).then((res) => {
				// for(let i=0;i<res.list.length;i++){
				//  res.list[i].text = res.list[i].cutMoney
				//  res.list[i].value = res.list[i].id
				// if(res.list[i].sendType == 3) {
				// 	this.coupons = res.list[i].id
				// }
				// }
				if (res.list.length > 0) {
					this.couponsTitle = "有可用优惠券"
					// this.coupons = res.list[0].id
				}
				this.couponsList = res.list;
			});
		},
		//查询满减信息
		selectDiscount(money) {
			this.$post({
				url: "/portal",
				module: "User",
				interface: "6004",
				data: {
					money: money,
				},
			}).then((res) => {
				console.log(res)
				if (res.list.length > 0) {
					var maxDiscount = 0;
					// if(res.list.length > 0) {
					// 	this.discountTitle = "有可参与满减活动"
					// }
					this.discountTitle = ""
					for (let i = 0; i < res.list.length; i++) {
						if (res.list[i].canUse) {
							console.log(parseFloat(res.list[i].cutMoney))
							console.log(parseFloat(maxDiscount))
							console.log(res.list[i].cutMoney > maxDiscount)
							console.log(parseFloat(res.list[i].cutMoney) > parseFloat(maxDiscount))
							if (parseFloat(res.list[i].cutMoney) > parseFloat(maxDiscount)) {
								maxDiscount = res.list[i].cutMoney
								this.discount = res.list[i].id;
								// this.coupons = e.cutMoney;
								this.discountTitle = res.list[i].name + res.list[i].cutMoney;
								this.newGoodsPrice = (this.info.goodsPrice - res.list[i].cutMoney).toFixed(3);
								this.coupons = ""
								this.couponsTitle = "不使用优惠券"

							}

							if (this.discountTitle == "不参与满减") {
								this.discountTitle = "有可参与满减活动"
							}
						}
					}
				}
				this.discountList = res.list;
			});
		},
		getDefAddress(id) {
			this.$post({
				module: "Address",
				interface: id ? "2002" : "3000",
				data: {
					id,
				},
			}).then((res) => {
				console.log("默认地址", res);
				this.address = id ? res : res.address;
			});
		},
	},
	components: {},
	created() {

		var now = new Date();
		var day = now.getDay();

		this.weekDay = day;
		console.log(this.$route.query.info, 11);
		console.log(this.$route.query.id, 123);
		this.shareUserId = this.$route.query.shareUserId;
		this.getDefAddress(this.$route.query.id);
		try {
			if (!this.$route.query.info) {
				throw new Error("没有info");
			}
			this.preOrder(JSON.parse(decodeURIComponent(this.$route.query.info)));

			// this.carIds = JSON.parse(decodeURIComponent(this.$route.query.carIds))
			// console.log(carIds,2)
		} catch (e) {
			console.log(e);
			this.$toast("订单信息加载失败");
			this.$router.back();
		}
		// let addId = localStorage.getItem("ADDRESS_ID_INFO");
		// localStorage.removeItem("ADDRESS_ID_INFO");
		// this.getDefAddress(addId);


		this.getJssdkConfig();

	},
	mounted() {



		// this.$nextTick(() => {
		// 	// var btn = document.getElementById('subscribe-btn');
		// 	var btn = this.$refs.subscribeBtn;

		// 	btn.addEventListener('success', function (e) {            
		// 		console.log('success', e.detail);
		// 		this.subscribe = true
		// 		this.$toast("订阅成功");
		// 	});   
		// 	btn.addEventListener('error',function (e) {             
		// 		console.log('fail', e.detail);
		// 		this.subscribe = false
		// 		this.$toast("必须订阅才能购买");
		// 	});
		// });
	},
};
</script>

<style scoped lang="less">
.order {
	height: 100vh;
	background: #fbfbfb;
	overflow: auto;
	font-family: PingFangSC-Regular, PingFang SC;
	padding-bottom: 65px;

	.bottom-bar {
		height: 49px;
		background-color: #fff;
		position: fixed;
		width: 100%;
		bottom: 0;
		display: flex;
		align-items: center;

		&>p {
			flex: 1;
			text-align: right;
			padding-right: 16px;

			span:first-child {
				font-size: 12px;
				color: #303133;
			}

			span:nth-child(2) {
				font-size: 14px;
				color: #fd0212;
				padding-right: 4px;
			}

			del {
				font-size: 14px;
				color: #919398;
			}
		}

		&>button {
			height: 100%;
			background-color: #fd0212;
			font-size: 18px;
			color: #ffffff;
			width: 128px;
			border-style: none;

			&:active {
				background-color: #d50614;
			}
		}
	}

	.icon {
		width: 22px;
		height: 22px;
	}

	.big-icon {
		width: 26px;
		height: 26px;
	}

	.base-card {
		background: #ffffff;
		box-shadow: 0px 6px 20px 0px rgba(16, 16, 16, 0.04);
		border-radius: 12px;
		overflow: hidden;
		margin-top: 14px;

		.card-title {
			padding: 20px 16px 0;
			font-size: 16px;
			color: #303133;

			&::after {
				content: "";
				display: block;
				height: 2px;
				background: linear-gradient(90deg, #fd0212 0%, #ffffff 100%);
				opacity: 0.3;
				margin-top: 9px;
			}
		}

		.card-content {
			padding: 18px 14px 28px 17px;

			.info-card {
				flex: 1;
				padding-left: 14px;
				word-break: break-all;

				&>div {
					margin-bottom: 8px;

					&>strong {
						font-size: 18px;
						color: #101010;
						padding-right: 10px;
					}

					&>span {
						color: #919398;
						font-size: 15px;
					}
				}

				&>p {
					font-size: 15px;
					color: #606266;
				}
			}

			&>.flex-between {
				margin-top: 16px;
				font-size: 13px;

				p {
					max-width: 50%;

					&:first-child {
						color: #414245;
						text-align: left;
					}

					&:last-child {
						color: #101010;
						text-align: right;

						&.main-color {
							color: #9d28b0;
						}
					}
				}
			}

			.selectCoupons {
				padding: 3px 5px;
			}

			.details-item {
				display: flex;
				height: 88px;
				margin-bottom: 16px;

				&:last-child {
					margin-bottom: 0;
				}

				.details-icon {
					width: 88px;
					height: 88px;
					background: #f5f7f6;
					box-shadow: 0px 2px 4px 0px rgba(16, 16, 16, 0.1);
					border-radius: 8px;
					object-fit: cover;
					margin-right: 10px;
				}

				&>.flex-column {
					flex-direction: column;
					height: 100%;
					flex: 1;
					padding-bottom: 20px;
					border-bottom: 1px solid #f0f0f0;

					p {
						font-size: 15px;
						color: #303133;
						width: 100%;
						text-align: left;

						&:last-child {
							font-size: 13px;
							color: #fd0212;
						}
					}
				}
			}
		}
	}
}
</style>
